import { useState } from 'react';
import { useSimStore } from '../store/simStore';
import './ControlPanel.css';

export const ControlPanel = () => {
  const { isPaused, setPaused, addCreature, spawnFood } = useSimStore();
  const [dnaInput, setDnaInput] = useState('');
  const [showRules, setShowRules] = useState(false);

  const handleCreateCreature = () => {
    if (dnaInput.trim()) {
      addCreature(dnaInput.trim());
      setDnaInput('');
    }
  };

  return (
    <>
      <div className="control-panel">
        <h1>Text Life Simulator</h1>
        <div className="controls">
          <button onClick={() => setPaused(!isPaused)}>
            {isPaused ? 'Resume' : 'Pause'}
          </button>
          <button onClick={() => spawnFood('plant')}>Spawn Plant</button>
          <button onClick={() => spawnFood('meat')}>Spawn Meat</button>
          <button onClick={() => setShowRules(!showRules)} className="rules-toggle">
            {showRules ? 'Hide Rules' : 'Show Rules'}
          </button>
        </div>
        <div className="creature-input">
          <input
            type="text"
            value={dnaInput}
            onChange={(e) => setDnaInput(e.target.value)}
            placeholder="Enter text to create a creature..."
          />
          <button onClick={handleCreateCreature}>Create</button>
        </div>
      </div>

      {showRules && (
        <div className="rules-panel">
          <h2>DNA Rules</h2>
          <ul>
            <li>Vowels determine body shape and size</li>
            <li>Consonants create appendages</li>
            <li>Capitalization affects color</li>
            <li>Punctuation adds special abilities</li>
            <li>Word length influences metabolism</li>
            <li>Word count affects reproduction rate</li>
          </ul>
        </div>
      )}
    </>
  );
}; 